import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TicketService } from '../../../../administrative/ticket/ticket.service';
import { FeiColumn } from '../../../../../../core/base/interfaces/fei-column.interface';
import { CorrectiveInterventionService } from '../../../../technique/corrective-intervention/corrective-intervention.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { EquipmentService } from '../../equipment.service';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LitigationStatusEnum } from '../../../../../../core/enums/litigation-status.enum';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';

@Component({
  selector: 'vex-equipment-details-service-book',
  templateUrl: './equipment-details-service-book.component.html',
  styleUrls: ['./equipment-details-service-book.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'fr' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'DD/MM/YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'DD/MM/YYYY',
        },
      },
    },
  ],
})
export class EquipmentDetailsServiceBookComponent implements OnInit, OnDestroy {
  dataSourceIntervention: MatTableDataSource<any>;
  displayedColumnsIntervention = [];
  feisColumnsIntervention: Array<FeiColumn> = [
    { label: 'Identifiant technique', column: 'technicalIdentifier' },
    { label: "Type d'intervention", column: 'intervention', previousDisplay: 'intervention ' },
    { label: 'Date planifiée', column: 'plannedDateAndTime', type: 'dateTime' },
    { label: "Date de l'intervention", column: 'startDateAndTime', type: 'dateTime' },
    { label: 'Intervenant', column: 'contributor', propertyDisplay: 'fullName' },
    { label: 'Description', column: 'description' },
    { label: 'Statut', column: 'status' },
  ];

  dataSourceHistory: MatTableDataSource<any>;
  displayedColumnsHistory = [];
  feisColumnsHistory: Array<FeiColumn> = [{ label: 'Identifiant technique', column: 'technicalIdentifier' }];
  sortField: string;
  sortOrder: string;
  pageIndex: number;
  pageSize: number;
  count = 0;

  filters: any = {};
  search: string;

  popupForm: UntypedFormGroup;
  countPopupFilter = 0;

  popupMonth: any[] = [
    { value: 1, viewValue: 'Depuis le 1er janvier' },
    { value: 12, viewValue: '12 dernier mois' },
    { value: 6, viewValue: '6 dernier mois' },
    { value: 3, viewValue: '3 dernier mois' },
  ];

  popupRange: UntypedFormGroup;
  ENUM_PERMISSION = ENUM_PERMISSIONS;

  private equipmentId: string;
  // EquipmentService est un singleton : sans désabonnement, l'écoute de entity$ survivrait à l'onglet et
  // relancerait ces chargements à chaque équipement ouvert ensuite.
  private readonly subscription = new Subscription();

  constructor(
    public interventionService: CorrectiveInterventionService,
    public equipmentService: EquipmentService,
    private ticketService: TicketService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.displayedColumnsIntervention = this.feisColumnsIntervention.map(x => x.column);
    this.displayedColumnsHistory = this.feisColumnsHistory.map(x => x.column);
  }

  ngOnInit(): void {
    this.popupRange = new UntypedFormGroup({
      start: new UntypedFormControl(null, Validators.required),
      end: new UntypedFormControl(null, Validators.required),
    });

    this.popupForm = new UntypedFormGroup({
      //modifier suite a la demande dans l'excel retours utilisateur ligne 13
      lastMonth: new UntypedFormControl(null),
      equipment: new UntypedFormControl(null),
      range: this.popupRange,
    });

    this.popupForm.get('lastMonth').valueChanges.subscribe(x => {
      if (x) {
        this.popupForm.get('range.start').setValue(null, { emitEvent: false });
        this.popupForm.get('range.end').setValue(null, { emitEvent: false });
      }
    });

    this.popupForm.get('range').valueChanges.subscribe(x => {
      if (x?.start && x?.end) {
        this.popupForm.get('lastMonth').reset(null, { onlySelf: true, emitEvent: false });
      }
    });

    // resetEntity() émet null à chaque changement d'équipement : ignoré, sinon la liste des interventions
    // serait chargée sans filtre équipement.
    this.subscription.add(
      this.equipmentService.entity$.pipe(filter(equipment => !!equipment?._id)).subscribe(equipment => {
        this.equipmentId = equipment._id;
        this.validatePopupFilter();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  init() {
    if (!this.equipmentId) {
      return;
    }
    this.filters.equipment = this.equipmentId;
    this.loadInterventions();
    this.loadIncidentTickets();
  }

  private loadInterventions(): void {
    this.subscription.add(
      this.interventionService
        .findAll(this.pageIndex, this.pageSize, this.sortField, this.sortOrder, this.search, this.filters)
        .subscribe(res => {
          res.data = res.data.map(x => {
            if (x.contributor) x.fullName = `${x?.contributor?.firstName} ${x?.contributor?.lastName}`;
            if (x.firstName && x.lastName) x.fullName = `${x?.firstName} ${x?.lastName}`;
            return x;
          });
          this.count = res.totalData;
          this.dataSourceIntervention = new MatTableDataSource<any>(res.data);
        }),
    );
  }

  private loadIncidentTickets(): void {
    this.subscription.add(
      this.ticketService
        .findAll(1, 'all', undefined, undefined, undefined, { equipmentId: this.equipmentId, isTicketEquipment: true })
        .subscribe(res => {
          this.dataSourceHistory = new MatTableDataSource<any>(res.data);
        }),
    );
  }

  pageEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.init();
  }

  sortEvent(event: Sort): void {
    this.sortField = event.active;
    this.sortOrder = event.direction;
    this.init();
  }

  onSearchChange(event) {
    this.pageIndex = 1;
    this.search = event;
    this.init();
  }

  clearTextFilter() {
    this.search = '';
    this.init();
  }

  async navigateToIntervention(element: any) {
    if (element.intervention === 'corrective') {
      await this.router.navigate(['/technique/correctiveIntervention', element._id]);
    } else {
      await this.router.navigate(['/technique/preventiveIntervention', element._id]);
    }
  }

  clearPopupFilter(): void {
    //clear popup ticket-filter logic
    // console.log(this.popupForm.getRawValue());

    // console.log(Object.values(this.popupForm.getRawValue()).ticket-filter(x => !x).length);
    this.popupForm.reset();
    if (Object.keys(this.filters).length > 0) {
      this.filters = {};
      this.countPopupFilter = 0;
      this.init();
    }
  }

  validatePopupFilter(): void {
    //validator popup ticket-filter logic
    this.filters = this.popupForm.value;
    this.countPopupFilter = 0;

    if (this.filters.lastMonth !== null || this.filters.range.start || this.filters.range.end) {
      this.countPopupFilter = 1;
    }

    // console.log('test', Object.entries(this.popupForm.value));
    // this.pageIndex = 1;
    this.init();
  }
}
